'use strict';

exports.SpinSystem = require('./SpinSystem');
exports.simulate1D = require('./simulate1D');
exports.simulate2D = require('./simulate2D');



//////////////////
// WEBPACK FOOTER
// ./~/nmr-simulation/src/index.js
// module id = 17
// module chunks = 0